import { Sparkles, Check } from "lucide-react";

/** Sélecteur des 5 propositions IA + vignette "Original". */
export function VariantsGrid({ photo, variants, selectedVariant, onSelect }) {
  return (
    <div
      id="ai-variants-grid"
      data-testid="ai-variants"
      className="glass-strong rounded-3xl p-6 md:p-8"
    >
      <div className="flex items-center gap-2 mb-5">
        <div className="w-8 h-8 rounded-lg bg-[#FF5A00]/15 text-[#FF5A00] flex items-center justify-center">
          <Sparkles size={16} />
        </div>
        <h3 className="text-sm uppercase tracking-[0.2em] text-white">
          5 propositions IA — choisissez votre base
        </h3>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3">
        <button
          type="button"
          onClick={() => onSelect(null)}
          data-testid="ai-variant-original"
          className={`rounded-xl overflow-hidden border-2 transition-all ${
            !selectedVariant
              ? "border-[#FF5A00]"
              : "border-white/10 hover:border-white/30"
          }`}
        >
          <div className="aspect-square">
            <img
              src={photo}
              alt="Original"
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="text-[10px] uppercase tracking-wider text-white py-1.5 bg-black/80">
            Original
          </div>
        </button>
        {variants.map((v) => {
          const active = selectedVariant === v.style;
          return (
            <button
              key={v.style}
              type="button"
              onClick={() => onSelect(v.style)}
              data-testid={`ai-variant-${v.style.toLowerCase().replace(/\s+/g, "-")}`}
              className={`rounded-xl overflow-hidden border-2 transition-all relative ${
                active
                  ? "border-[#FF5A00]"
                  : "border-white/10 hover:border-white/30"
              }`}
            >
              <div className="aspect-square">
                <img
                  src={v.data_url}
                  alt={v.style}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-[10px] uppercase tracking-wider text-white py-1.5 bg-black/80 leading-tight px-1">
                {v.style}
              </div>
              {active && (
                <div className="absolute top-2 right-2 w-5 h-5 rounded-full bg-[#FF5A00] flex items-center justify-center">
                  <Check size={12} className="text-white" />
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
